<a [routerLink]="['/produtos', product.codigo]" class="product-card card">
  <!-- Badges -->
  <div class="card-badges">
    @if (hasLowStock) {
      <span class="badge badge-low-stock">Últimas Unidades</span>
    }
  </div>

  <!-- Imagem -->
  <div class="card-image-wrapper">
    <img 
      [src]="product.imagemURL" 
      [alt]="product.nome"
      class="card-image"
      loading="lazy"
    />
  </div>

  <!-- Conteúdo -->
  <div class="card-body">
    <!-- Nome do produto -->
    <h3 class="card-title">{{ product.nome }}</h3>

    <!-- Informações do veículo -->
    @if (vehicleText) {
      <p class="card-vehicle">{{ vehicleText }}</p>
    }

    <!-- Preço -->
    <div class="card-price">
      <span class="currency">R$</span>
      <span class="value">{{ formatPrice(product.preco) }}</span>
    </div>

    <!-- Parcelamento simulado -->
    <p class="card-installment">em 12x sem juros</p>
  </div>
</a>

